<template>
  <div>
    <base-drawer :open="open" :close="close" title="Reativar Cupom">
      <base-card>
        <base-label text="Defina uma nova expiração" class="mb_20" />
        <base-input
          class="mb_0 w-100"
          type="tel"
          autocomplete="none"
          v-model="expiration"
          :mask="StringLanguage.dateMask"
          :masked="true"
        />
      </base-card>
      <template slot="footer">
        <base-button
          class="w-100"
          :text="'Reativar Cupom'"
          @click="reactivateCoupon()"
        />
      </template>
    </base-drawer>

    <!-- <base-drawer
      title="Cupom reativado com sucesso!"
      :open="messageDrawer.open"
      :close="messageDrawer.close"
      @onClose="$emit('onFinishReactivation')"
    >
      <coupons-message />
      <template slot="footer">
        <base-button
          @click="closeMessageDrawer"
          class="w-100"
          :text="'Concluir'"
        />
      </template>
    </base-drawer> -->
  </div>
</template>

<script>
import BaseButton from '@/components/Button';
import BaseCard from '@/components/Card';
import BaseDrawer from '@/components/Drawer';
import BaseLabel from '@/components/Label';
import BaseInput from '@/components/Input';
import CouponsMessage from '@/containers/Coupons/Forms/CouponsMessage';

import GiftAPI from '@/api/coupon';
import Utils from '@/utils';

export default {
  props: {
    couponCode: { type: String },
    open: { type: Boolean, default: false },
    close: { type: Boolean, default: false },
  },
  data() {
    return {
      expiration: null,
      messageDrawer: { open: false, close: false },
    };
  },
  methods: {
    reactivateCoupon() {
      const couponExpiration = this.expiration
        ? new Date(Utils.switchDayMonth(this.expiration)).getTime() / 1000
        : null;
      if (couponExpiration < Date.now() / 1000) {
        return alert('Data de expiração inválida.');
      }

      GiftAPI.reactivate(this.couponCode, couponExpiration).then((response) => {
        if (response.getErrors([]).length > 0) {
          return alert(StringLanguage.saveError);
        }
        alert('Cupom reativado com sucesso', '', () => {
          this.$emit('onFinishReactivation');
          this.$router.push('sales');

          setTimeout(() => {
            this.$router.push('cupons');
          }, 1);
        });
      });
    },
    openMessageDrawer() {
      this.messageDrawer.open = !this.messageDrawer.open;
    },
    closeMessageDrawer() {
      this.messageDrawer.close = !this.messageDrawer.close;
      this.$emit('onFinishReactivation');
      this.$router.push('cupons');
      setTimeout(() => {
        this.$router.push('cupons/expired');
      }, 1);
    },
  },
  components: {
    BaseButton,
    BaseCard,
    BaseDrawer,
    BaseLabel,
    BaseInput,
    CouponsMessage,
  },
};
</script>

<style scoped></style>
